package one.healthium.domain.user.models

sealed interface SignInOptions {
    data class Username(
        val username: String,
        val password: String,
    ) : SignInOptions

    data class CustomToken(
        val token: String,
        val email: String,
    ) : SignInOptions
}
